import api from '../../server';

export default {
  namespaced: true,
  state: {
    products: {
      data: []
    },
    product: {
    },
    brandId: 0,
    catId: 29
  },
  actions: {
    fetchProductList ({ commit }, { params }) {
      return api.Products(params).then(data => commit('setProductList', { data }))
    },
    fetchProductData ({ commit }, { params }) {
      return api.Product(params).then(data => commit('setProductData', { data }))
    },
    fetchProductCreate ({ commit }, { params }) {
      return api.Test(params).then(data => commit('setProductCreate', { data }))
    }
  },
  mutations: {
    setProductList (state, data) {
      state.products = data.data.data
    },
    setProductData (state, data) {
      state.product = data.data.data
    },
    setProductCreate (state, data) {
      state.order = data.data
    },
    setCatId (state, data) {
      state.catId = data
    },
    setBrandId (state, data) {
      state.brandId = data
    }
  }
}
